import {BaseSearchDTO} from "../API";

export interface TermsTemplateSearchDTO extends BaseSearchDTO {
  filters?: {
    customerId?: string;
    hideDeleted?: boolean;
  };
}
